const ROOT_ID = 'teleport-place'
const STYLE_ID = 'overlay-layers-style'

const LAYERS = ['features', 'modals', 'dropdowns', 'notifications']

export const OVERLAY_LAYER_TARGETS = LAYERS.reduce((acc, name) => {
  acc[name] = `#teleport-${name}`
  return acc
}, {})

const ROOT_Z_INDEX = 9990

export const CONFETTI_Z_INDEX = 9991

const STYLE = `
/* Full-size root: iOS Safari drops tap hit-testing for content overflowing a 0x0 fixed ancestor (FE-661) */
#${ROOT_ID} { position: fixed; inset: 0; z-index: var(--z-overlay-root, ${ROOT_Z_INDEX}); pointer-events: none; }
#${ROOT_ID} > div { isolation: isolate; }
#${ROOT_ID} > div > * { pointer-events: auto; }
`

export function ensureOverlayLayers() {
  if (typeof document === 'undefined') return

  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style')
    style.id = STYLE_ID
    style.textContent = STYLE
    document.head.appendChild(style)
  }

  if (document.getElementById(ROOT_ID)) return

  const root = document.createElement('div')
  root.id = ROOT_ID
  for (const name of LAYERS) {
    const layer = document.createElement('div')
    layer.id = `teleport-${name}`
    root.appendChild(layer)
  }
  document.body.appendChild(root)
}

export function overlayLayerTarget(layer) {
  if (typeof document === 'undefined') return 'body'
  ensureOverlayLayers()
  return OVERLAY_LAYER_TARGETS[layer]
}
